import { left, right } from 'fp-ts/Either';
import { httpClientFunction } from 'domain/types';
import ReadLocationClient from 'use-case/location/readLocationClient';
import Location, { LocationType } from 'domain/entity/location';
import ReadLocationCriteria from 'use-case/location/readLocationCriteria';

export default (httpClient: httpClientFunction, baseUrl: string): ReadLocationClient => (criteria: ReadLocationCriteria) =>
    httpClient(`${baseUrl}/locations/${criteria.locationId}`, {})
        .then((response) =>
            response.ok
                ? response
                      .json()
                      .then(asLocation)
                      .then(right)
                      .catch(() => left({ error: new Error(), status: 500 }))
                : left({ error: new Error(), status: response.status })
        )
        .catch(() => left({ error: new Error(), status: 503 }));

const asLocation = (locationJson: JsonLocation): Location => {
    if (
        locationJson.id !== undefined &&
        locationJson.key !== undefined &&
        locationJson.name !== undefined &&
        locationJson.type !== undefined
    ) {
        const children = (locationJson.children || []).map(asLocation);

        return new Location(locationJson.id, locationJson.key, locationJson.name, locationJson.type, locationJson.tags, children);
    }

    throw new ReferenceError('Invalid Location provided');
};

type JsonLocation = {
    id: number;
    key: string;
    name: string;
    type: LocationType;
    tags: string[];
    children: JsonLocation[];
};
